import * as authApi from "@hub/authentication/src/api/auth.api"
import createErrorMessage from "@shared/factories/src/errorMessage.factory"

export const login = async payload => {
  try {
    const { data } = await authApi.login(payload)
    return data
  } catch (error) {
    throw error
  }
}

export const verify = async payload => {
  try {
    const { data } = await authApi.verify(payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Falha ao verificar e-mail."
    })
    throw error
  }
}

export const resetPassword = async payload => {
  try {
    const { data } = await authApi.resetPassword(payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Falha ao redefinir senha."
    })
    throw error
  }
}

export const sendResetPassword = async payload => {
  try {
    const { data } = await authApi.sendResetPassword(payload)
    return data
  } catch (error) {
    console.error(error)
  }
}

export const changeMyPassword = async (uuid, payload) => {
  try {
    const { data } = await authApi.changeMyPassword(uuid, payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Erro ao redefinir a senha. Por favor tente novamente"
    })
    throw error
  }
}

export const changeMyUserPhoto = async (uuid, payload) => {
  try {
    const { data } = await authApi.changeMyUserPhoto(uuid, payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || ""
    })
    throw error
  }
}

export const fetchRoles = async () => {
  try {
    const { data } = await authApi.fetchRoles()
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || ""
    })
  }
}

export const updateMyAccount = async (uuid, payload) => {
  try {
    const { data } = await authApi.updateMyAccount(uuid, payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || ""
    })
    throw error
  }
}

export const generateToken = async payload => {
  try {
    const { data, message } = await authApi.generateToken(payload)
    window.$vue.$toast({
      type: "success",
      title: message
    })
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: error?.response?.data?.message || "Falha ao enviar token."
    })
    throw error
  }
}

export const resendToken = async payload => {
  try {
    const { data, message } = await authApi.resendToken(payload)
    window.$vue.$toast({
      type: "success",
      title: message
    })
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: error?.response?.data?.message || "Falha ao reenviar token."
    })
    throw error
  }
}

export const validateToken = async payload => {
  try {
    const { data, message } = await authApi.validateToken(payload)
    window.$vue.$toast({
      type: "success",
      title: message
    })
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: error?.response?.data?.message || "Token não encontrado."
    })
    throw error
  }
}

export const getSendTokenTypes = async () => {
  try {
    const { data } = await authApi.getSendTokenTypes()
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: error?.response?.data?.message || "Falha ao obter tipos de envio."
    })
  }
}

export const sendContactToken = async (contactType, payload) => {
  try {
    const { data } = await authApi.sendContactToken(contactType, payload)
    return data
  } catch (error) {
    window.$vue.$toast({
      type: "error",
      title: error?.response?.data?.message || "Falha ao enviar código."
    })

    throw error
  }
}

export const resendContactToken = async (contactType, payload) => {
  try {
    const { data } = await authApi.resendContactToken(contactType, payload)
    return data
  } catch (error) {
    window.$vue.$toast({
      type: "error",
      title: error?.response?.data?.message || "Falha ao reenviar código."
    })

    throw error
  }
}

export const validateContactToken = async (contactType, payload) => {
  try {
    const { data } = await authApi.validateContactToken(contactType, payload)
    return data
  } catch (error) {
    window.$vue.$toast({
      type: "error",
      title: error?.response?.data?.message || "Falha ao validar código."
    })

    throw error
  }
}